import { useQuery, gql } from "@apollo/client";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface FabricTypeSelectProps {
  field: any;
}

export const GET_FABRIC_TYPES = gql`
  query {
    __type(name: "FabricType") {
      name
      enumValues {
        name
      }
    }
  }
`;

const FabricTypeSelect: React.FC<FabricTypeSelectProps> = ({ field }) => {
  const { data, loading, error } = useQuery(GET_FABRIC_TYPES);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading fabric types</div>;

  const fabricTypes = data?.__type?.enumValues || [];

  return (
    <Select onValueChange={field.onChange} value={field.value}>
      <SelectTrigger>
        <SelectValue placeholder="Select a fabric type" />
      </SelectTrigger>
      <SelectContent>
        {fabricTypes.map((type: any) => (
          <SelectItem key={type.name} value={type.name}>
            {type.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default FabricTypeSelect;
